import { FileText, Download } from 'lucide-react';
import PageHero from '@/components/PageHero';

const RESOURCES = [
  { section: 'Forms & Applications', items: ['Membership Application', 'Ministerial Ordination Form', 'Department Registration', 'AIM Convention Registration'] },
  { section: 'Leadership Resources', items: ['Pastor\'s Handbook', 'Department Leader Manual', 'Ordination Study Guide', 'Board of Trustees Guidelines'] },
  { section: 'Documents', items: ['Jurisdictional Constitution', 'Statement of Faith', 'Meeting Minutes (Quarterly)', 'Annual Report'] },
  { section: 'Policies', items: ['Safeguarding & Child Protection', 'Financial Policy', 'Media & Communications Policy', 'Code of Conduct'] },
];

export default function Resources() {
  return (
    <div>
      <PageHero slug="resources" overline="Equipped to Serve" heading="Resources" text="Forms, publications, and downloads for members and leaders." />
      <section className="bg-white py-20">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-8">
          {RESOURCES.map(r => (
            <div key={r.section} className="card-tactile p-8">
              <h3 className="font-serif text-2xl text-royal font-bold mb-4">{r.section}</h3>
              <ul className="space-y-3">
                {r.items.map(i => (
                  <li key={i} className="flex items-center justify-between border-b border-gray-100 pb-3 last:border-0">
                    <span className="flex items-center gap-2 text-charcoal-muted"><FileText className="w-4 h-4 text-gold" /> {i}</span>
                    <button data-testid={`download-${i.replace(/\s/g, '-')}`} className="text-royal hover:text-gold"><Download className="w-4 h-4" /></button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
